export default [
  {
    key: 'status',
    label: 'label.status',
    rules: 'required',
    cols: 12,
    type: 'single-selection',
    rows: '2',
    options: [
      {
        value: 'active',
        name: 'label.active',
      },
      {
        value: 'inactive',
        name: 'label.inActive',
      },
    ],
  },
]
